import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Subscribe from './Subscribe';
const publicKey = window.StripeKey;
const stripePromise = loadStripe(publicKey);
export default function BillingSubscrbe(props) {  
 
    return (
        <Elements stripe={stripePromise} >
            <Subscribe {...props} />
        </Elements>
    );
}
